import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/homeData';
import supabase from '@/lib/supabase';

export default function Footer() {
  const [sitemapOpen, setSitemapOpen] = useState(false);
  const [siteLogo, setSiteLogo] = useState('');
  const [siteName, setSiteName] = useState('스카연');

  useEffect(() => {
    supabase
      .from('site_settings')
      .select('key, value')
      .in('key', ['site_logo', 'site_name'])
      .then(({ data }) => {
        if (data) {
          const logoEntry = data.find((d) => d.key === 'site_logo');
          const nameEntry = data.find((d) => d.key === 'site_name');
          if (logoEntry?.value) setSiteLogo(logoEntry.value);
          if (nameEntry?.value) setSiteName(nameEntry.value);
        }
      })
      .catch(() => {});
  }, []);

  const sitemapSections = [
    {
      title: '주요 서비스',
      links: [
        { label: '먹튀검증', href: '/search' },
        { label: '피해사례', href: '/board' },
        { label: '피해제보', href: '/report' },
        { label: '커뮤니티', href: '/board' },
      ],
    },
    {
      title: '이용안내',
      links: [
        { label: '예방가이드', href: '/#prevention' },
        { label: '검증기준', href: '/#verification' },
        { label: 'FAQ', href: '/#faq' },
        { label: '이용약관', href: '#' },
        { label: '개인정보처리방침', href: '#' },
      ],
    },
    {
      title: '고객지원',
      links: [
        { label: '고객센터', href: '/report' },
        { label: '공지사항', href: '/board' },
        { label: '로그인', href: '/login' },
        { label: '회원가입', href: '/register' },
      ],
    },
  ];

  return (
    <>
      <footer className="bg-secondary-950 text-foreground-300">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                {siteLogo ? (
                  <img src={siteLogo} alt={siteName} className="h-8 md:h-10 object-contain" />
                ) : (
                  <>
                    <div className="w-8 h-8 bg-primary-500 rounded flex items-center justify-center">
                      <span className="text-white font-bold text-sm">스</span>
                    </div>
                    <span className="text-xl font-bold text-primary-500">{siteName}</span>
                  </>
                )}
              </div>
              <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
                먹튀검증 및 피해예방을 위한
                <br />
                안전한 커뮤니티입니다.
              </p>
              <div className="flex gap-3">
                <a
                  href="#"
                  className="w-8 h-8 bg-secondary-800 rounded flex items-center justify-center hover:bg-primary-500 transition-colors"
                  aria-label="카카오톡"
                >
                  <i className="ri-kakao-talk-fill text-sm" />
                </a>
                <a
                  href="#"
                  className="w-8 h-8 bg-secondary-800 rounded flex items-center justify-center hover:bg-primary-500 transition-colors"
                  aria-label="텔레그램"
                >
                  <i className="ri-telegram-fill text-sm" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">서비스</h4>
              <ul className="space-y-2">
                {footerLinks.services.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/#') ? (
                      <a
                        href={link.href}
                        className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : link.href !== '#' ? (
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-400 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <span className="text-sm text-foreground-400">{link.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">이용안내</h4>
              <ul className="space-y-2">
                {footerLinks.guides.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/#') ? (
                      <a
                        href={link.href}
                        className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : link.href !== '#' ? (
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-400 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <span className="text-sm text-foreground-400">{link.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">고객센터</h4>
              <ul className="space-y-2">
                {footerLinks.company.map((link) => (
                  <li key={link.label}>
                    {link.href === '#sitemap' ? (
                      <button
                        onClick={() => setSitemapOpen(true)}
                        className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </button>
                    ) : link.href.startsWith('/#') ? (
                      <a
                        href={link.href}
                        className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : link.href !== '#' ? (
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-400 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <span className="text-sm text-foreground-400">{link.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">정책</h4>
              <ul className="space-y-2">
                {footerLinks.legal.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/#') ? (
                      <a
                        href={link.href}
                        className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : link.href !== '#' ? (
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-400 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <span className="text-sm text-foreground-400">{link.label}</span>
                    )}
                  </li>
                ))}
                <li>
                  <button
                    onClick={() => setSitemapOpen(true)}
                    className="flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-menu-line" />
                    전체메뉴
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-800 text-center text-xs text-foreground-500">
            <p>© 2026 스카연. All rights reserved.</p>
            <p className="mt-1">
              스카연은 사용자들의 안전한 온라인 게임 환경을 위해 노력합니다. 본 사이트에서
              제공되는 모든 정보는 참고용이며, 이용에 따른 책임은 이용자 본인에게 있습니다.
            </p>
          </div>
        </div>
      </footer>

      {sitemapOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          role="dialog"
          aria-modal="true"
          aria-label="전체 메뉴"
        >
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setSitemapOpen(false)}
          />
          <div className="relative z-10 bg-white rounded-xl w-full max-w-2xl max-h-[80vh] overflow-y-auto mx-4 shadow-2xl animate-[fadeIn_0.2s_ease-out]">
            <div className="sticky top-0 z-10 bg-white border-b border-foreground-200 px-6 py-4 flex items-center justify-between rounded-t-xl">
              <div className="flex items-center gap-2">
                {siteLogo ? (
                  <img src={siteLogo} alt={siteName} className="h-7 object-contain" />
                ) : (
                  <>
                    <div className="w-7 h-7 bg-primary-500 rounded flex items-center justify-center">
                      <span className="text-white font-bold text-xs">스</span>
                    </div>
                  </>
                )}
                <h2 className="text-base font-bold text-foreground-950">전체 메뉴</h2>
              </div>
              <button
                onClick={() => setSitemapOpen(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="닫기"
              >
                <i className="ri-close-line text-lg text-foreground-600" />
              </button>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                {sitemapSections.map((section) => (
                  <div key={section.title}>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-4 pb-2 border-b border-foreground-200">
                      {section.title}
                    </h3>
                    <ul className="space-y-3">
                      {section.links.map((item) => (
                        <li key={item.label}>
                          {item.href.startsWith('/#') ? (
                            <a
                              href={item.href}
                              onClick={() => setSitemapOpen(false)}
                              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-2 cursor-pointer"
                            >
                              <i className="ri-arrow-right-s-line text-foreground-400" />
                              {item.label}
                            </a>
                          ) : (
                            <Link
                              to={item.href}
                              onClick={() => setSitemapOpen(false)}
                              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-2"
                            >
                              <i className="ri-arrow-right-s-line text-foreground-400" />
                              {item.label}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              <div className="mt-8 pt-6 border-t border-foreground-200 text-center">
                <Link
                  to="/report"
                  onClick={() => setSitemapOpen(false)}
                  className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
                >
                  <i className="ri-customer-service-2-line" />
                  고객센터 문의하기
                </Link>
                <p className="text-xs text-foreground-400 mt-3">
                  평일 09:00 - 18:00 / 주말 및 공휴일 휴무
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}